import { TypographyProps } from '@material-ui/core';
import { Variant } from '@material-ui/core/styles/createTypography';

import { Font, TITLE_COLOR_ID } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

export interface CustomFormLabelProps {
  label: string;
  strongTitle?: boolean;
  forceSingleLine?: boolean;
  labelDynamicDataTexts?: string[];
  variant?: 'inherit' | Variant;
  color?: TypographyProps['color'] | typeof TITLE_COLOR_ID;
  markAsOptional?: boolean;
  disableTranslation?: boolean;
}

export const CustomFormLabel = ({
  label,
  strongTitle,
  forceSingleLine = true,
  labelDynamicDataTexts,
  variant = 'subtitle2',
  color = 'textSecondary',
  markAsOptional = false,
  disableTranslation = false,
}: CustomFormLabelProps) => {
  return (
    <Font
      className={forceSingleLine ? 'overflow-text-ellipsis' : ''}
      variant={variant}
      color={color}
      style={{
        lineHeight: '1.1rem',
        ...(forceSingleLine ? { minWidth: 0, width: '100%', display: 'block' } : {}),
      }}
    >
      {disableTranslation ? label : <Text strong={strongTitle} tId={label} dynamicDataTexts={labelDynamicDataTexts} />}
      {markAsOptional && (
        <span style={{ opacity: 0.5, paddingLeft: '0.5em' }}>
          {'('}
          <Text tId={'OPTIONAL'} />
          {')'}
        </span>
      )}
    </Font>
  );
};
